export default __webpack_public_path__ + "static/media/no-invoice.013237e4.svg";